import { sendRequest } from "../ajax/ajax_es.js";
import { initFlyerMiniatures } from "../monitoring/monitoring-products-common.js";
import { showPlaceholder, hidePlaceholder } from "./lazy-load.js";
import { appendValidity } from "../grid/validity-filter.js";

export function init(callback)
{
    // inicializace eventu
    const buttons = document.getElementsByClassName('next-button');
    const contents = document.getElementsByClassName('next-data-ph');

    if(buttons.length == contents.length)
    {
        for(let i = 0; i < buttons.length; i++)
        {
            let button = buttons[i];
            let content = contents[i];

            button.addEventListener('click', () => { lazyLoading(button, content, callback); });
        }
    }
}

const buttonIdToLazyloadingPlaceholderIdMap = {
    'load-products-button': 'products-lazyloading-placeholder',
    'loadMoreStores': 'dealer-lazyloading-placeholder',
    'loadMoreBranches': 'branch-lazyloading-placeholder',
    'loadMoreLocalities': 'localities-lazyloading-placeholder',
    'monitoring-table-button': 'monitoring-table-lazyloading-placeholder',
}

// zavěsíme na paginator
function lazyLoading(button, content, callback)
{
    const isMonitoringTable = button.id === 'monitoring-table-button';

    let lazyLoadPlaceholderId = '';
    if (isMonitoringTable) {
        const isAmp = !!!button.dataset;
        const prefix = isAmp ? button.attributes.find((attribute) => attribute.name === 'data-scope').value : button.dataset.scope;
 
        lazyLoadPlaceholderId = `${prefix}-${buttonIdToLazyloadingPlaceholderIdMap[button.id]}`
    } else {
        lazyLoadPlaceholderId = buttonIdToLazyloadingPlaceholderIdMap[button.id];
    }
    const placeholderDisplayStyle = isMonitoringTable ? 'table-footer-group' : 'block';

    const page = parseInt(content.getAttribute('data-page'));
    const column = content.getAttribute('data-col');
    const order = prepareOrder(content, false);

    content.setAttribute('data-page', (page + 1));

    let urlAjax = prepareAjaxUrl(content, page, column, order);

    if (lazyLoadPlaceholderId) {
        showPlaceholder(lazyLoadPlaceholderId, placeholderDisplayStyle);
    }

    sendRequest(urlAjax, function (xmlhttp) {

        const snippetResponse = xmlhttp.response;
        const snippets = snippetResponse.snippets;

        for (var i in snippets) {
            const leaflets = snippets[i];
            content.innerHTML += leaflets;
            break;
        }

        if(callback)
        {
            callback();
        }
        const lastLeafletDetail = content.getElementsByClassName("last-detail");

        if(lastLeafletDetail.length > 0)
        {
            button.style.display = "none";
            //content.removeAttribute('data-link');
            //content.removeAttribute('data-page');
        }
        if (lazyLoadPlaceholderId) {
            hidePlaceholder(lazyLoadPlaceholderId);

            if (isMonitoringTable) {
                initFlyerMiniatures();
            }
        }
    });
}

export function prepareOrder(orderSource, change)
{
    let order = orderSource.getAttribute('data-order');

    if(!change)
    {
        return order;
    }

    if(!order)
    {
        order = 'desc';
    }

    if(order == 'desc')
    {
        order = 'asc';
    }
    else
    {
        order = 'desc';
    }
    return order;
}

function prepareAjaxUrl(content, page, column, order)
{
    let urlAjax = content.getAttribute('data-link');
    urlAjax = urlAjax.replace(/-page=\d+/, "-page=" + page);
    urlAjax = urlAjax.replace(/-order=[asc|desc]+/, "-order=" + order);
    urlAjax = urlAjax.replace(/-column=[0|a-z]+/, "-column=" + column);

    if (content.hasAttribute('data-archive') === true) {
        let archive = content.getAttribute('data-archive');
        urlAjax = urlAjax.replace(/-archive=\d+/, "-archive=" + archive);
    }

    // Zachovat aktivní filtr platnosti (od-do) i při donačítání.
    urlAjax = appendValidity(urlAjax, content);

    return urlAjax;
}